module.exports = __webpack_public_path__ + "static/media/DAY.52817506.png";